// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home_wrapper[data-v-5499b757]{width:100%;height:auto;padding-top:0}.home_container[data-v-5499b757]{display:flex;justify-content:center;align-items:flex-start;width:100%;height:var(--com-base-top-container-h2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
